import {Component} from '@angular/core';

/**
 * Generated class for the LoadingComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'loading-button',
    templateUrl: 'loading-button.html'
})
export class LoadingButtonComponent {

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./src/components/loading-button/loading-button.ts